import React from 'react'
import { router, usePage } from '@inertiajs/react'

import { Checkbox, Input } from '@material-tailwind/react'
import Select from 'react-tailwindcss-select'

import LoadingButton from '@/Shared/LoadingButton'

const packages = [
  {
    label: 'Package 1',
    value: 'Package 1'
  },
  {
    label: 'Package 2',
    value: 'Package 2'
  },
  {
    label: 'Package 3',
    value: 'Package 3'
  },
  {
    label: 'Package 4',
    value: 'Package 4'
  },
  {
    label: 'Package 5',
    value: 'Package 5'
  },
  {
    label: 'Package 6',
    value: 'Package 6'
  },
  {
    label: 'Package 7',
    value: 'Package 7'
  },
  {
    label: 'Package 8',
    value: 'Package 8'
  },
  {
    label: 'Package 9',
    value: 'Package 9'
  },
  {
    label: 'Package 10',
    value: 'Package 10'
  },
  {
    label: 'Package 11',
    value: 'Package 11'
  },
  {
    label: 'Package 12',
    value: 'Package 12'
  },
  {
    label: 'Package 13',
    value: 'Package 13'
  },
  {
    label: 'Package 14',
    value: 'Package 14'
  },
  {
    label: 'Package 15',
    value: 'Package 15'
  }
]

export default function ({
  handleSubmit,
  hospitals,
  errors,
  data,
  setData,
  processing,
  isEdit
}) {
  const { items, laundryItem } = usePage().props

  const types = ['washed', 'received']

  const getLabel = () => {
    if (data.type === 'washed') {
      return 'Dispatch'
    }

    return 'Washed'
  }

  return (
    <form name="createForm" onSubmit={handleSubmit} className="mt-8">
      <div className="flex flex-col gap-4 md:flex-row">
        {data.type === 'dispatch' ? (
          <Input
            size="lg"
            label="Indent No"
            name="indent_no"
            error={errors.indent_no}
            value={data.indent_no}
            onChange={e => setData('indent_no', e.target.value)}
          />
        ) : (
          <Select
            label="Select Indent No"
            name="indent_no"
            primaryColor="indigo"
            classNames={{
              menuButton: ({ isDisabled }) =>
                `flex text-sm ${errors.package ? 'text-red-500' : 'text-gray-500'} border ${errors.package ? 'border-red-300' : 'border-gray-300'} rounded shadow-sm transition-all duration-300 focus:outline-none ${
                  isDisabled
                    ? 'bg-gray-200'
                    : 'bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20'
                }`
            }}
            value={
              data.indent_no && {
                value: data.indent_no,
                label: items[data.indent_no]
              }
            }
            isSearchable
            options={Object.entries(items).map(item => ({
              label: item[1],
              value: item[0]
            }))}
            onChange={({ value }) => {
              if (data.type !== 'dispatch') {
                router.get(
                  route(route().current(), data.type),
                  {
                    indent_no: value
                  },
                  {
                    replace: true
                  }
                )
              }

              setData('indent_no', value)
            }}
          />
        )}
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {typeof hospitals === 'object' && (
          <Select
            label="Select Hospital"
            name="hospital_id"
            primaryColor="indigo"
            classNames={{
              menuButton: ({ isDisabled }) =>
                `flex text-sm ${errors.hospital_id ? 'text-red-500' : 'text-gray-500'} border ${errors.hospital_id ? 'border-red-300' : 'border-gray-300'} rounded shadow-sm transition-all duration-300 focus:outline-none ${
                  isDisabled
                    ? 'bg-gray-200'
                    : 'bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20'
                }`
            }}
            value={
              data.hospital_id && {
                value: data.hospital_id,
                label: hospitals.find(
                  hospital => hospital.id === data.hospital_id
                ).name
              }
            }
            isSearchable
            options={hospitals.map(hospital => ({
              label: hospital.name,
              value: hospital.id
            }))}
            isDisabled={types.includes(data.type)}
            onChange={option => setData('hospital_id', option.value)}
          />
        )}

        <Select
          label="Select Package"
          name="package"
          primaryColor="indigo"
          classNames={{
            menuButton: ({ isDisabled }) =>
              `flex text-sm ${errors.package ? 'text-red-500' : 'text-gray-500'} border ${errors.package ? 'border-red-300' : 'border-gray-300'} rounded shadow-sm transition-all duration-300 focus:outline-none ${
                isDisabled
                  ? 'bg-gray-200'
                  : 'bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20'
              }`
          }}
          value={
            data.package && {
              value: data.package,
              label: data.package
            }
          }
          isSearchable
          options={packages}
          isDisabled={types.includes(data.type)}
          onChange={option => setData('package', option.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Bed Sheet`}
            error={errors.bed_sheet}
            value={laundryItem?.bed_sheet}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Bed Sheet"
          name="bed_sheet"
          type="number"
          max={laundryItem?.bed_sheet}
          error={errors.bed_sheet}
          value={data.bed_sheet}
          onChange={e => setData('bed_sheet', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Blanket`}
            value={laundryItem?.blanket}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Blanket"
          name="blanket"
          type="number"
          max={laundryItem?.blanket}
          error={errors.blanket}
          value={data.blanket}
          onChange={e => setData('blanket', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Gown`}
            value={laundryItem?.gown}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Gown"
          name="gown"
          type="number"
          max={laundryItem?.gown}
          error={errors.gown}
          value={data.gown}
          onChange={e => setData('gown', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Pillow Cover`}
            value={laundryItem?.pillow_cover}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Pillow Cover"
          name="pillow_cover"
          type="number"
          max={laundryItem?.pillow_cover}
          error={errors.pillow_cover}
          value={data.pillow_cover}
          onChange={e => setData('pillow_cover', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Curtain`}
            value={laundryItem?.curtain}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Curtain"
          name="curtain"
          type="number"
          max={laundryItem?.curtain}
          error={errors.curtain}
          value={data.curtain}
          onChange={e => setData('curtain', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Table Cloth`}
            value={laundryItem?.table_cloth}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Table Cloth"
          name="table_cloth"
          type="number"
          max={laundryItem?.table_cloth}
          error={errors.table_cloth}
          value={data.table_cloth}
          onChange={e => setData('table_cloth', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Draw Sheet`}
            value={laundryItem?.draw_sheet}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Draw Sheet"
          name="draw_sheet"
          type="number"
          max={laundryItem?.draw_sheet}
          error={errors.draw_sheet}
          value={data.draw_sheet}
          onChange={e => setData('draw_sheet', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} OT Kit`}
            value={laundryItem?.ot_kit}
            disabled
          />
        )}

        <Input
          size="lg"
          label="OT Kit"
          name="ot_kit"
          type="number"
          max={laundryItem?.ot_kit}
          error={errors.ot_kit}
          value={data.ot_kit}
          onChange={e => setData('ot_kit', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} OT Gown`}
            value={laundryItem?.ot_gown}
            disabled
          />
        )}

        <Input
          size="lg"
          label="OT Gown"
          name="ot_gown"
          type="number"
          max={laundryItem?.ot_gown}
          error={errors.ot_gown}
          value={data.ot_gown}
          onChange={e => setData('ot_gown', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Apron Bearers`}
            value={laundryItem?.apron_bearers}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Apron Bearers"
          name="apron_bearers"
          type="number"
          max={laundryItem?.apron_bearers}
          error={errors.apron_bearers}
          value={data.apron_bearers}
          onChange={e => setData('apron_bearers', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        {data.type !== 'dispatch' && (
          <Input
            size="lg"
            label={`${getLabel()} Washroom Towels`}
            value={laundryItem?.washroom_towels}
            disabled
          />
        )}

        <Input
          size="lg"
          label="Washroom Towels"
          name="washroom_towels"
          type="number"
          error={errors.washroom_towels}
          max={laundryItem?.washroom_towels}
          value={data.washroom_towels}
          onChange={e => setData('washroom_towels', e.target.value)}
        />
      </div>

      <div className="mt-6 flex flex-col gap-4 md:flex-row">
        <div className="w-full">
          <Checkbox
            size="lg"
            label="Feeder"
            name="is_feeder"
            color={'indigo'}
            defaultChecked={data.is_feeder}
            disabled={types.includes(data.type)}
            onChange={e => setData('is_feeder', e.target.checked)}
          />
        </div>
      </div>

      <div className="mt-8 flex items-center justify-end border-t border-gray-200 bg-gray-100 px-8 py-4">
        <LoadingButton
          loading={processing}
          type="submit"
          className="btn-indigo"
        >
          {isEdit ? 'Update' : 'Add'} Laundry
        </LoadingButton>
      </div>
    </form>
  )
}
